<template>
  <li
    class="list-none my-1 mx-0 border-b dark:border-gray-700"
    :tabindex="null"
    :aria-disabled="true"
  />
</template>
<script>
export default {};
</script>
